@let isDesktop = deviceService.isDesktop$ | async;

<form
  class="workflow-form"
  (ngSubmit)="sync()"
  [ngClass]="{ 'max-w-[950px]': isDesktop }"
>
  <!-- Final Page Content -->
  <div class="workflow-form-main">
    <h2 class="workflow-title text-[28px]/[32px] font-extrabold mb-4">
      {{ 'workflows.final_page_title' | translate }}
    </h2>
    <p class="x-text-dark-75 x-font-body-2 mb-6">
      {{ 'workflows.final_page_description' | translate }}
    </p>

    <!-- Блок с ошибками валидации -->
    @if ($validationErrors().length > 0) {
      <div class="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
        <div class="flex items-baseline gap-2 mb-3">
          <span class="text-2xl">⚠️</span>
          <h3 class="workflow-title x-font-body-2-bold x-text-wf-error">
            Обнаружены ошибки валидации
          </h3>
        </div>

        <p class="x-font-body-4 x-text-wf-error mb-4">
          Пожалуйста, исправьте следующие ошибки перед завершением:
        </p>

        <div class="space-y-3">
          @for (
            error of $validationErrors();
            track error.fieldKey +
              error.workflowId +
              error.nodeId +
              error.formId
          ) {
            <a
              [routerLink]="[
                $baseRoute(),
                'workflows',
                error.workflowUUID,
                error.nodeNumericId,
                error.formNumericId,
              ]"
              class="block x-white border border-red-200 rounded p-3 cursor-pointer hover:border-red-300 hover:bg-red-50 transition-colors"
            >
              <div
                class="flex flex-wrap items-center gap-1 x-font-body-4 x-text-dark-main mb-2"
              >
                <span>{{ error.workflowTitle }}</span>
                <span class="mb-0.5">→</span>
                <span>{{ error.nodeTitle }}</span>
                <span class="mb-0.5">→</span>
                <span>{{ error.formTitle }}</span>
              </div>
              <div class="flex items-start gap-2">
                <span class="x-text-wf-error font-medium">•</span>
                <div>
                  <span class="font-semibold x-text-dark-main"
                    >{{ error.fieldTitle }}:</span
                  >
                  <span class="x-text-wf-error ml-1 font-bold">{{
                    error.errorMessage
                  }}</span>
                </div>
              </div>
            </a>
          }
        </div>
      </div>
    } @else {
      <section>
        <x-workflow-stepper [baseRoute]="$baseRoute()" [isFinalPage]="true" />
      </section>
    }
  </div>

  <!-- Footer Section -->
  <div
    class="workflow-form-footer text-center"
    [ngClass]="{ 'ps-6': isDesktop }"
  >
    @if ($areWorkflowsCompleted()) {
      <p class="x-font-body-3 x-text-dark-75 mb-4">
        {{ 'workflows.final_page_completed' | translate }}
      </p>
    } @else {
      <p class="x-font-body-3 x-text-dark-75">
        {{ 'workflows.final_page_attention' | translate }}
      </p>

      @if ($blockingItems().length > 0) {
        <div
          tuiNotification
          size="m"
          appearance="warning"
          class="mt-4 text-start"
        >
          <p>{{ 'workflows.screen_state.final_blocked_title' | translate }}</p>
          <ul class="mt-2 list-disc ps-5 typo-body-s">
            @for (item of $blockingItems(); track $index) {
              <li>
                {{ 'workflows.screen_state.item_' + item.kind | translate }}
                @if (item.formTitle) {
                  «{{ item.formTitle }}»
                }
                —
                {{
                  (item.status === 'failed'
                    ? 'workflows.screen_state.item_failed'
                    : 'workflows.screen_state.item_pending'
                  ) | translate
                }}
                @if (item.error) {
                  ({{ item.error }})
                }
              </li>
            }
          </ul>
        </div>
      }
      @if ($pendingWork().unknown) {
        <div tuiNotification size="m" appearance="negative" class="mt-4">
          {{ 'workflows.pending_state_unknown' | translate }}
        </div>
      }

      <button
        tuiButton
        type="submit"
        size="m"
        class="mt-4"
        appearance="primary"
        [ngClass]="{
          'w-full': !isDesktop,
          'min-w-[600px]': isDesktop,
        }"
        [disabled]="$isSubmitting() || !$canSubmit()"
        [loading]="$isSubmitting()"
      >
        {{ 'workflows.final_page_sync' | translate }}
      </button>
    }
  </div>
</form>
